import React, { useEffect, useState } from 'react';
import Offcanvas from 'react-bootstrap/Offcanvas';
import { ActivarDesactivarEspecialidad, ControllerEliminarEspecialidad, EspecialidadClinica } from '../../../Service/Service.especialidad';
import { GetTokenDecoded } from '../../../utils/storeUsuario';
import EspecialidadCreate from './EspecialidadCreate';
import usePermissions from '../../../hook/usePermissions';
import useListaLocal from '../../../hook/useListaLocal';
import DataTable from '../../UI/DataTable/DataTable';
import { Celda, CeldaDoble } from '../../UI/DataTable/piezas';
import { ChipEstado } from '../../UI/Chip';
import MenuAcciones from '../../UI/MenuAcciones';
import Boton from '../../UI/Boton';
import Modal from '../../UI/Modal/Modal';
import { useToast } from '../../UI/Aviso';
import { CampoTexto } from '../../UI/Campo';
import { IconoMas, IconoEditar, IconoEliminar, IconoCheck, IconoCerrar, IconoBuscar } from '../../UI/Iconos';


export default function Especialidad({tabs}) {
    // RBAC-CUTOVER-07: Anadir/Activar-Desactivar/Editar dependen de
    // especialidades.edit (backend gatea POST /especialidades_clinica con
    // ese mismo permiso -- ver especialidad.routes.ts); Eliminar depende de
    // especialidades.delete.
    const { hasPermission } = usePermissions();
    const [show, setShow] = useState(false);

    const [ping, setPing] = useState(false);
    const [especialidadEditar, setespecialidadEditar] = useState(null);

    const [especialidadesClinica, setEspecialidadesClinica] = useState([]);
    const [cargando, setCargando] = useState(false);
    const [error, setError] = useState(null);
    const [porBorrar, setPorBorrar] = useState(null);
    const [borrando, setBorrando] = useState(false);
    const { mostrar } = useToast();
    const lista = useListaLocal(especialidadesClinica, { campos: ["especialidad", "codigo", "clinica"] });

    // El servicio devuelve `undefined` si la petición falla (su `catch` no
    // retorna nada), así que aquí NUNCA se puede leer `res.success` a secas:
    // eso reventaba la pestaña entera con un TypeError.
    const recargar = async () => {
        setCargando(true);
        const res = await EspecialidadClinica(GetTokenDecoded().idclinica);
        if (res?.success) {
            setEspecialidadesClinica(res.data);
            setError(null);
        } else {
            setEspecialidadesClinica([]);
            setError(res?.message || "No se pudo obtener las especialidades de la clínica.");
        }
        setCargando(false);
    };

    const EditarEstado = async(doctor) => {
        // Se envía una COPIA con el estado volteado. El original hacía
        // `doctor.estado = !doctor.estado` sobre la fila que estaba pintada:
        // la pantalla se creía el cambio antes de que el servidor dijera nada,
        // y si el servidor lo rechazaba se quedaba mintiendo. Los campos que
        // viajan son los mismos.
        const rest = await ActivarDesactivarEspecialidad({ ...doctor, estado: !doctor.estado })
        if(rest?.success){
          mostrar({ tipo: "exito", texto: "Se actualizó correctamente" });
        } else {
          mostrar({ tipo: "error", texto: "No se pudo cambiar el estado de la especialidad." });
        }
        // En los dos casos se vuelve a pedir la verdad al servidor.
        await recargar();
    }

    const EliminarEspecialidad = async(doctor) => {
        setBorrando(true);
        const rest = await ControllerEliminarEspecialidad(doctor.idclinica_especialidad)
        setBorrando(false);
        setPorBorrar(null);
        if(rest?.success){
            mostrar({ tipo: "exito", texto: "Especialidad eliminada." });
            await recargar();
        } else {
            mostrar({ tipo: "error", texto: rest?.message || "No se pudo eliminar la especialidad." });
        }
    }

    const EditarEspecialidad = (doctor) => {
      setespecialidadEditar(doctor)
      handleShow()
    }
    const handleClose = () =>{
      setespecialidadEditar(null)
      setShow(false)
    };
    const handleShow = () => setShow(true);

    useEffect(() => {
        recargar();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [ping, tabs.especialidades]);

    const columnas = [
      {
        key: "especialidad",
        titulo: "Especialidad",
        render: (e) => <CeldaDoble principal={e.especialidad} secundario={e.codigo} />,
      },
      { key: "clinica", titulo: "Clínica", ancho: 240, render: (e) => <Celda valor={e.clinica} /> },
      {
        key: "icono",
        titulo: "Icono",
        ancho: 90,
        alinear: "centro",
        render: (e) =>
          // Antes, una especialidad sin icono pintaba `<img src="">`, que es
          // el icono de imagen rota. Si no hay icono, se dice.
          e.icono && e.icono !== "null" ? (
            <img src={e.icono} width="32" height="32" alt={`Icono de ${e.especialidad}`} />
          ) : (
            <Celda valor="Sin icono" />
          ),
      },
      {
        key: "estado",
        titulo: "Estado",
        ancho: 120,
        render: (e) => (
          <ChipEstado tono={e.estado ? "hecho" : "anulado"}>{e.estado ? "Activo" : "Inactivo"}</ChipEstado>
        ),
      },
      {
        key: "acciones",
        titulo: "",
        ancho: 60,
        alinear: "centro",
        render: (e) => {
          const acciones = [];
          if (hasPermission("especialidades.edit")) {
            acciones.push({
              label: e.estado ? "Desactivar" : "Activar",
              icono: e.estado ? IconoCerrar : IconoCheck,
              onClick: () => EditarEstado(e),
            });
            acciones.push({ label: "Editar", icono: IconoEditar, onClick: () => EditarEspecialidad(e) });
          }
          if (hasPermission("especialidades.delete")) {
            acciones.push({ label: "Eliminar", icono: IconoEliminar, peligro: true, onClick: () => setPorBorrar(e) });
          }
          return acciones.length > 0 ? <MenuAcciones acciones={acciones} titulo={`Acciones de ${e.especialidad}`} /> : null;
        },
      },
    ];

  return (
    <section>
      {hasPermission("especialidades.edit") && (
        <div className="d-flex justify-content-end mb-3">
          <Boton variante="primario" icono={IconoMas} onClick={handleShow} data-testid="especialidad-crear">
            Añadir nueva especialidad
          </Boton>
        </div>
      )}

      <div className="mb-3" style={{ maxWidth: 380 }}>
        <CampoTexto
          etiqueta="Buscar especialidad"
          icono={IconoBuscar}
          placeholder="Nombre o código"
          value={lista.texto}
          onChange={(e) => lista.setTexto(e.target.value)}
          data-testid="especialidad-buscar"
        />
      </div>

      <DataTable
        columnas={columnas}
        filas={lista.visibles}
        filaKey="idclinica_especialidad"
        cargando={cargando}
        error={error}
        onReintentar={recargar}
        etiquetaTabla="Especialidades de la clínica"
        hayFiltrosAplicados={lista.hayBusqueda}
        onLimpiarFiltros={lista.limpiar}
        textoVacioSinFiltros="Esta clínica todavía no tiene especialidades activadas."
        paginacion={lista.paginacion}
      />

      {/* Eliminar una especialidad no pedía confirmación ni decía nada después:
          se pulsaba y, con suerte, la fila desaparecía. */}
      <Modal
        abierto={Boolean(porBorrar)}
        titulo="Eliminar especialidad"
        destructivo
        onCerrar={() => setPorBorrar(null)}
        secundario={{ label: "Cancelar" }}
        primario={{
          label: "Eliminar",
          cargando: borrando,
          onClick: () => EliminarEspecialidad(porBorrar),
        }}
      >
        <p>
          Vas a eliminar <b>{porBorrar?.especialidad}</b> de esta clínica. Esta acción no se puede deshacer.
        </p>
      </Modal>

      <Offcanvas style={{ width: '50%' }} placement="end" show={show} onHide={handleClose}>
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>Activacion de Especialidad
          </Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <EspecialidadCreate
            handleClose={handleClose}
            setPing={setPing}
            ping={ping}
            setShow={setShow}
            especialidadeditar={especialidadEditar}
          />
        </Offcanvas.Body>
      </Offcanvas>
    </section>
  )
}
